export const BORDER_WIDTH = 2;

export const INPUT_RANGE_HEIGHT = 35;
export const INPUT_RANGE_THUMB_SIZE = 31;
